import *as THREE from 'three'


export type ModeOfAnim = number

export default class {
  mesh: THREE.Mesh | THREE.Object3D 
  active = false
  paused = true
  rotationAlpha = .2 
  opacityAlpha = .1
  scaleAlpha = .05
  mode: ModeOfAnim = 1
  
  constructor(mesh: THREE.Mesh | THREE.Object3D) {
    this.mesh = mesh

    mesh.scale.set(0.001, 1, 0.001)
  }  

  setMode(mode: ModeOfAnim) {
    this.mode = mode
  }

  setActive(active: boolean) {
    this.active = active
  }

  play() {
    this.paused = false
  }

  pause() {
    this.paused = true
  }

  stop() {
    this.active = false
    this.paused = true
    this.mesh.scale.set(1,1,1)

    //@ts-ignore
    this.mesh.material.opacity = 0
  }
  
  updateScale() {
    const { mesh, mode, paused } = this

    const { x: currentScale } = mesh.scale
    
    const targetScale = !paused ? +(1 / mode).toFixed(2) : .001
    
    if(currentScale < targetScale) {
      const nextScale = currentScale + this.scaleAlpha

      mesh.scale.set(nextScale, 1, nextScale)
    }

    if(currentScale > targetScale) {
      const nextScale = currentScale - this.scaleAlpha 

      mesh.scale.set(nextScale, 1, nextScale)
    }
  }
  
  updateOpacity() {
    const { mesh, opacityAlpha, paused } = this
    
    //@ts-ignore
    const targetOpacity = (mesh.material.opacity + opacityAlpha * (paused ? -1 : 1))

      
    if(targetOpacity <= 1 && targetOpacity >= 0) {
      //@ts-ignore
      mesh.material.opacity = +targetOpacity.toFixed(1)
    }
  }
  
  update() {
    const { mesh, rotationAlpha } = this

    if(this.active) {
      mesh.rotation.set(0, rotationAlpha + mesh.rotation.y, 0)  
      this.updateScale()
      this.updateOpacity()
    }
  }
}